import { label_children, bigScreen_label_children, app_label_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"

const cxLabel = {
  name: "cxLabel",
  desc: "状态标签",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    app: [
      {
        name: "状态标签",
        children: app_label_children,
        group: "element",
        sort: 130,
        cover: require("assets/images/leftMenu/button/style1.png")
      }
    ],
    bigScreen: [
      {
        name: "状态标签",
        children: bigScreen_label_children,
        group: "component",
        sort: 70
      }
    ],
    portal: [
      {
        name: "状态标签",
        children: label_children,
        cover: require("assets/images/leftMenu/button/style1.png"),
        group: "element",
        sort: 130
      }
    ]
  },
  toolbars: [
    {
      name: "cxLabel",
      label: "状态标签",
      comp: {
        labelComponentData: () => import("./toolbars/label-options-data.vue"),
        labelComponentSetting: () => import("./toolbars/label-options-setting.vue"),
        labelComponentConfig: () => import("./toolbars/label-options-config.vue")
      }
    }
  ]
}

export default cxLabel
